import * as React from "react";
import { Action, IOWidget, mk_widget } from "widgets-for-react";
import "intersection-observer";
import { InView } from "react-intersection-observer";
import { CMSState } from "../types.gen";
import { getClassName } from "../utils.gen";
import { blockInviewHandler } from "../../../drupal/rendering/inview_utils.mod";

export type QuoteBlockNestedProps<extra_images> = {
  index: number
  text: string
  author?: string
  inview?: {
    threshold?: number
    triggerOnce?: boolean
  }
}

export type QuoteBlockNestedStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  content_classname: string
  quote_classname: string
  quote_text_classname: string
  author_classname: string
}>

export function QuoteBlockNested<customBlockData, extra_images>(
  props: QuoteBlockNestedProps<extra_images>,
  options?: { style?: QuoteBlockNestedStyle; key?: string }
): IOWidget<CMSState<customBlockData,extra_images, never>, Action<CMSState<customBlockData,extra_images, never>>> {
return (cmsState: CMSState<customBlockData,extra_images, never>) =>
    mk_widget({
      run: _ => {
        return (
          <InView
            as="figure"
            onChange={(inView) => blockInviewHandler('quote', inView, `io-${options && options.key ? options.key : props.index}`, getClassName(options, "inview_classname", "inview"))}
            triggerOnce={props.inview && props.inview.triggerOnce ? props.inview.triggerOnce : false}
            threshold={props.inview && props.inview.threshold ? props.inview.threshold : 0.1}
            id={`io-${options && options.key ? options.key : props.index}`}
            className={getClassName(options, "block_classname", "")}
            key={options && options.key ? options.key : `block-${props.index}`}
          >
            <div className={getClassName(options, "inner_classname", "py-5")}>
              <div className={getClassName(options, "content_classname", "text-center")}>
                {props.text && (
                  <blockquote className={getClassName(options, "quote_classname", "")}>
                    <p className={getClassName(options, "quote_text_classname", "h4")}>{props.text}</p>
                  </blockquote>
                )}
                {props.author && <figcaption className={getClassName(options, "author_classname", "mb-3 text-muted")}><cite>— {props.author}</cite></figcaption>}
              </div>
            </div>
          </InView>
        )
      },
    })
}
